import {getAssetItem} from 'src/utils/helpers'

const PIANO_SAMPLES = {
  'A1': getAssetItem('audio/samples/piano/A1_small.mp3'),
  'A2': getAssetItem('audio/samples/piano/A2_small.mp3'),
  'A3': getAssetItem('audio/samples/piano/A3_small.mp3'),
  'A4': getAssetItem('audio/samples/piano/A4_small.mp3'),
  'A5': getAssetItem('audio/samples/piano/A5_small.mp3'),
  'A6': getAssetItem('audio/samples/piano/A6_small.mp3'),
  'A7': getAssetItem('audio/samples/piano/A7_small.mp3'),
  'A#1': getAssetItem('audio/samples/piano/As1_small.mp3'),
  'A#2': getAssetItem('audio/samples/piano/As2_small.mp3'),
  'A#3': getAssetItem('audio/samples/piano/As3_small.mp3'),
  'A#4': getAssetItem('audio/samples/piano/As4_small.mp3'),
  'A#5': getAssetItem('audio/samples/piano/As5_small.mp3'),
  'A#6': getAssetItem('audio/samples/piano/As6_small.mp3'),
  'A#7': getAssetItem('audio/samples/piano/As7_small.mp3'),
  'B1': getAssetItem('audio/samples/piano/B1_small.mp3'),
  'B2': getAssetItem('audio/samples/piano/B2_small.mp3'),
  'B3': getAssetItem('audio/samples/piano/B3_small.mp3'),
  'B4': getAssetItem('audio/samples/piano/B4_small.mp3'),
  'B5': getAssetItem('audio/samples/piano/B5_small.mp3'),
  'B6': getAssetItem('audio/samples/piano/B6_small.mp3'),
  'B7': getAssetItem('audio/samples/piano/B7_small.mp3'),
  'C1': getAssetItem('audio/samples/piano/C1_small.mp3'),
  'C2': getAssetItem('audio/samples/piano/C2_small.mp3'),
  'C3': getAssetItem('audio/samples/piano/C3_small.mp3'),
  'C4': getAssetItem('audio/samples/piano/C4_small.mp3'),
  'C5': getAssetItem('audio/samples/piano/C5_small.mp3'),
  'C6': getAssetItem('audio/samples/piano/C6_small.mp3'),
  'C7': getAssetItem('audio/samples/piano/C7_small.mp3'),
  'C#1': getAssetItem('audio/samples/piano/Cs1_small.mp3'),
  'C#2': getAssetItem('audio/samples/piano/Cs2_small.mp3'),
  'C#3': getAssetItem('audio/samples/piano/Cs3_small.mp3'),
  'C#4': getAssetItem('audio/samples/piano/Cs4_small.mp3'),
  'C#5': getAssetItem('audio/samples/piano/Cs5_small.mp3'),
  'C#6': getAssetItem('audio/samples/piano/Cs6_small.mp3'),
  'C#7': getAssetItem('audio/samples/piano/Cs7_small.mp3'),
  'D1': getAssetItem('audio/samples/piano/D1_small.mp3'),
  'D2': getAssetItem('audio/samples/piano/D2_small.mp3'),
  'D3': getAssetItem('audio/samples/piano/D3_small.mp3'),
  'D4': getAssetItem('audio/samples/piano/D4_small.mp3'),
  'D5': getAssetItem('audio/samples/piano/D5_small.mp3'),
  'D6': getAssetItem('audio/samples/piano/D6_small.mp3'),
  'D7': getAssetItem('audio/samples/piano/D7_small.mp3'),
  'D#1': getAssetItem('audio/samples/piano/Ds1_small.mp3'),
  'D#2': getAssetItem('audio/samples/piano/Ds2_small.mp3'),
  'D#3': getAssetItem('audio/samples/piano/Ds3_small.mp3'),
  'D#4': getAssetItem('audio/samples/piano/Ds4_small.mp3'),
  'D#5': getAssetItem('audio/samples/piano/Ds5_small.mp3'),
  'D#6': getAssetItem('audio/samples/piano/Ds6_small.mp3'),
  'D#7': getAssetItem('audio/samples/piano/Ds7_small.mp3'),
  'E1': getAssetItem('audio/samples/piano/E1_small.mp3'),
  'E2': getAssetItem('audio/samples/piano/E2_small.mp3'),
  'E3': getAssetItem('audio/samples/piano/E3_small.mp3'),
  'E4': getAssetItem('audio/samples/piano/E4_small.mp3'),
  'E5': getAssetItem('audio/samples/piano/E5_small.mp3'),
  'E6': getAssetItem('audio/samples/piano/E6_small.mp3'),
  'E7': getAssetItem('audio/samples/piano/E7_small.mp3'),
  'F1': getAssetItem('audio/samples/piano/F1_small.mp3'),
  'F2': getAssetItem('audio/samples/piano/F2_small.mp3'),
  'F3': getAssetItem('audio/samples/piano/F3_small.mp3'),
  'F4': getAssetItem('audio/samples/piano/F4_small.mp3'),
  'F5': getAssetItem('audio/samples/piano/F5_small.mp3'),
  'F6': getAssetItem('audio/samples/piano/F6_small.mp3'),
  'F7': getAssetItem('audio/samples/piano/F7_small.mp3'),
  'F#1': getAssetItem('audio/samples/piano/Fs1_small.mp3'),
  'F#2': getAssetItem('audio/samples/piano/Fs2_small.mp3'),
  'F#3': getAssetItem('audio/samples/piano/Fs3_small.mp3'),
  'F#4': getAssetItem('audio/samples/piano/Fs4_small.mp3'),
  'F#5': getAssetItem('audio/samples/piano/Fs5_small.mp3'),
  'F#6': getAssetItem('audio/samples/piano/Fs6_small.mp3'),
  'F#7': getAssetItem('audio/samples/piano/Fs7_small.mp3'),
  'G1': getAssetItem('audio/samples/piano/G1_small.mp3'),
  'G2': getAssetItem('audio/samples/piano/G2_small.mp3'),
  'G3': getAssetItem('audio/samples/piano/G3_small.mp3'),
  'G4': getAssetItem('audio/samples/piano/G4_small.mp3'),
  'G5': getAssetItem('audio/samples/piano/G5_small.mp3'),
  'G6': getAssetItem('audio/samples/piano/G6_small.mp3'),
  'G7': getAssetItem('audio/samples/piano/G7_small.mp3'),
  'G#1': getAssetItem('audio/samples/piano/Gs1_small.mp3'),
  'G#2': getAssetItem('audio/samples/piano/Gs2_small.mp3'),
  'G#3': getAssetItem('audio/samples/piano/Gs3_small.mp3'),
  'G#4': getAssetItem('audio/samples/piano/Gs4_small.mp3'),
  'G#5': getAssetItem('audio/samples/piano/Gs5_small.mp3'),
  'G#6': getAssetItem('audio/samples/piano/Gs6_small.mp3'),
  'G#7': getAssetItem('audio/samples/piano/Gs7_small.mp3'),
};

export {
  PIANO_SAMPLES
}
